"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loggable = exports.defaultLogger = exports.getLogger = exports.DEFAULT_OPTIONS = void 0;
const moment_1 = __importDefault(require("moment"));
const winston_1 = require("winston");
const { combine, timestamp, printf, json } = winston_1.format;
const logLevel = 'silly';
exports.DEFAULT_OPTIONS = {
    logLevel,
    timeFormat: 'YYYY-MM-DD HH:mm:ss.SSS',
    transports: [new winston_1.transports.Console()],
};
/**
 * Create new logger with specific parameters.
 *
 * Usage examples:
 * {{{
 *
 *   logger.error("Error occurred", error); // Will print error with its stack trace information
 *
 *   logger.debug("debug message", {duration: 100}); // Will print debug message with time duration in ms
 *
 * }}}
 *
 * @param fnOpts  Object containing logging settings:
 *                  - logLevel: [default 'silly'],]
 *                  - timeFormat: [default 'YYYY-MM-DD HH:mm:ss.SSS']
 *                Options override priority: function options -> defaults from {@link DEFAULT_OPTIONS}
 * @returns {*}
 */
const getLogger = (fnOpts = {}, transports = [new winston_1.transports.Console()], format) => {
    const opts = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), fnOpts);
    if (!format) {
        format = combine(timestamp(), printf((info) => `[${(0, moment_1.default)(info.timestamp).format(opts.timeFormat)} ${info.level.toUpperCase()}] : ${info.message}`));
    }
    return (0, winston_1.createLogger)({
        format,
        level: opts.logLevel,
        transports,
        exceptionHandlers: transports,
    });
};
exports.getLogger = getLogger;
exports.defaultLogger = (0, exports.getLogger)({ logLevel });
class Loggable {
    constructor(loggableOptions) {
        const opts = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), loggableOptions);
        this.logger = (0, winston_1.createLogger)({
            format: combine(timestamp(), printf((info) => `[${(0, moment_1.default)(info.timestamp).format(opts.timeFormat)} ${info.level.toUpperCase()}] : ${info.message}`)),
            level: opts.logLevel,
            transports: opts.transports,
        });
    }
}
exports.Loggable = Loggable;
//# sourceMappingURL=index.js.map